/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesEmployeesDtosEmployeeDto,
  FacilityFlowCoreModulesEmployeesDtosForgotPasswordRequest,
  FacilityFlowCoreModulesEmployeesDtosForgotPasswordResponse,
  FacilityFlowCoreModulesEmployeesDtosLoginRequest,
  FacilityFlowCoreModulesEmployeesDtosLoginResponse,
  FacilityFlowCoreModulesEmployeesDtosValidateResetTokenRequest
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getAuth = () => {
/**
 * @summary Login with PersonalNumber and Password
 */
const postApiV1AuthLogin = (
    facilityFlowCoreModulesEmployeesDtosLoginRequest: FacilityFlowCoreModulesEmployeesDtosLoginRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesEmployeesDtosLoginResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesEmployeesDtosLoginResponse>(
      {url: `/api/v1/auth/login`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesEmployeesDtosLoginRequest
    },
      options);
    }
  /**
 * @summary Logout current user
 */
const postApiV1AuthLogout = (
    
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/auth/logout`, method: 'POST'
    },
      options);
    }
  /**
 * @summary Generate password reset token and send via email/SMS
 */
const postApiV1AuthForgotPassword = (
    facilityFlowCoreModulesEmployeesDtosForgotPasswordRequest: FacilityFlowCoreModulesEmployeesDtosForgotPasswordRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesEmployeesDtosForgotPasswordResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesEmployeesDtosForgotPasswordResponse>(
      {url: `/api/v1/auth/forgot-password`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesEmployeesDtosForgotPasswordRequest
    },
      options);
    }
  /**
 * @summary Reset password with token (from email/SMS link)
 */
const postApiV1AuthResetPassword = (
    facilityFlowCoreModulesEmployeesDtosValidateResetTokenRequest: FacilityFlowCoreModulesEmployeesDtosValidateResetTokenRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/auth/reset-password`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesEmployeesDtosValidateResetTokenRequest
    },
      options);
    }
  /**
 * @summary Get current authenticated user info
 */
const getApiV1AuthMe = (
    
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesEmployeesDtosEmployeeDto>>,) => {
      return customInstance<FacilityFlowCoreModulesEmployeesDtosEmployeeDto>(
      {url: `/api/v1/auth/me`, method: 'GET'
    },
      options);
    }
  return {postApiV1AuthLogin,postApiV1AuthLogout,postApiV1AuthForgotPassword,postApiV1AuthResetPassword,getApiV1AuthMe}};
export type PostApiV1AuthLoginResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAuth>['postApiV1AuthLogin']>>>
export type PostApiV1AuthLogoutResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAuth>['postApiV1AuthLogout']>>>
export type PostApiV1AuthForgotPasswordResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAuth>['postApiV1AuthForgotPassword']>>>
export type PostApiV1AuthResetPasswordResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAuth>['postApiV1AuthResetPassword']>>>
export type GetApiV1AuthMeResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getAuth>['getApiV1AuthMe']>>>
